module.exports = __webpack_public_path__ + "6fdc0ce9bdb27c69194aac507ade2092.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/footerlogo1.jpg
// module id = 439
// module chunks = 0